// src/lib/controle-detail-api.js — LE DÉTAIL D'UN CONTRÔLE (Suivi équipe).
//
// Client de l'action serveur `controle_detail` (lib/controles-handlers.js,
// routée par /api/beds24-mapping, requireRole admin+orchestrateur — dispatch
// dédié, PAS le triplet contrôle terrain). Fichier SÉPARÉ de controle-api.js
// (chantier parallèle : additions seulement, jamais dans ses fichiers).
//
// Le cloisonnement est SERVEUR (parc frais de l'orchestrateur, 404 indistinct
// hors parc) ; `controleur_prenom` n'arrive que pour l'admin — le client
// affiche ce qu'il reçoit, il ne décide de rien. Auth : Bearer JWT Supabase
// (même pattern que controle-api.js).

import { supabase } from '../supabase'

const ENDPOINT = '/api/beds24-mapping'

/**
 * controleId → { statut, reprise_par, cree_le, repris_le, agent_prenom,
 *   controleur_prenom? (admin seulement), points: [{ categorie, texte,
 *   photos: [url signée TTL 600 s] }], reprise: [{ index, fait, fait_le }] }
 * Erreur HTTP → Error avec `status` ; erreur réseau → Error avec `reseau`.
 */
export async function fetchControleDetail(controleId) {
  let res
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ action: 'controle_detail', controle_id: controleId }),
    })
  } catch (e) {
    // Erreur réseau — message générique, jamais de PII.
    const err = new Error('Connexion impossible. Réessayez.')
    err.reseau = true
    throw err
  }
  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(json.error || `Erreur ${res.status}`)
    err.status = res.status
    throw err
  }
  return json
}

/**
 * LA DÉCISION SUR UNE REPRISE (feuille « Une reprise en attente », admin).
 * choix 'moi' | 'agent' (+agentEmail) | 'bon' (+raison OBLIGATOIRE serveur).
 * Rend { ok, erreur?, avertissement? } — le pattern de designerControleurRun.
 */
export async function deciderReprise({ controleId, choix, agentEmail, raison }) {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (!token) return { ok: false, erreur: 'Session expirée' }
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        action: 'controle_reprise_decider',
        controle_id: controleId,
        choix,
        ...(agentEmail ? { agent_email: agentEmail } : {}),
        ...(raison ? { raison } : {}),
      }),
    })
    const json = await res.json().catch(() => ({}))
    if (!res.ok) return { ok: false, erreur: json?.error || `Erreur ${res.status}` }
    return { ok: true, avertissement: json?.avertissement || null }
  } catch (e) {
    console.error('[accueil] controle_reprise_decider', e?.message || e)
    return { ok: false, erreur: 'Connexion impossible. Réessayez.' }
  }
}
